import { pathExists } from 'fs-extra';
import { Logger } from '../utils/logger';
import { fileReplacement } from '../utils/file-replacement';

export class FileReplacementUpgrader {
    private sourceContentFilePath: string;
    private writeToFilePath: string;

    private messages = {
        notFound: '',
        sourceFileNotFound: ''
    };

    /**
     * the constructor.
     * @param sourceContentFilePath the source file path.
     * @param writeToFilePath the write to file path.
     * @param fileName the file name.
     */
    constructor(sourceContentFilePath: string, writeToFilePath: string, fileName?: string) {
        this.sourceContentFilePath = sourceContentFilePath;
        this.writeToFilePath = writeToFilePath;

        this.messages.notFound = `${fileName} writeToFilePath not found at ${this.writeToFilePath}.`
        this.messages.sourceFileNotFound = `${fileName} sourceContentFilePath not found at ${this.sourceContentFilePath}.`
    }

    /**
     * the run function to resolve the errors.
     */
    public async run(): Promise<void> {
        try {
            const exists = await pathExists(this.sourceContentFilePath);
            const writeToFilePathExists = await pathExists(this.writeToFilePath);

            if (!exists) {
                Logger.log(this.messages.sourceFileNotFound);
            }

            if (!writeToFilePathExists) {
                Logger.log(this.messages.notFound);
            }
            if (exists && writeToFilePathExists) {
                await fileReplacement(this.sourceContentFilePath, this.writeToFilePath)
            }
        } catch (error) {
            Logger.error(error);
        }
    }
}
